var React = require('react');

function ChargerInline (props) {
    return React.createElement("svg",props,[React.createElement("polygon",{"points":"30.91 13.18 9.06 13.18 9.06 22.88 11.9 25.72 11.94 25.77 14.78 28.61 25.13 28.61 28.01 25.73 28.01 25.72 11.94 25.72 11.94 15.87 28.01 15.87 28.01 25.72 28.02 25.72 30.89 22.84 30.91 13.18","key":0}),React.createElement("rect",{"x":"14.66","y":"7","width":"2.89","height":"6.17","key":1}),React.createElement("rect",{"x":"22.34","y":"7","width":"2.89","height":"6.17","key":2}),React.createElement("rect",{"x":"18.54","y":"26.82","width":"2.89","height":"6.17","key":3})]);
}

ChargerInline.defaultProps = {"id":"Warstwa_1","data-name":"Warstwa 1","width":"32","height":"32","viewBox":"0 0 40 40"};

module.exports = ChargerInline;

ChargerInline.default = ChargerInline;
